import React from 'react';
import { Spinner } from '@servicetitan/design-system';
import RedirectForbidden from '@app/permissions/RedirectForbidden';
import { useBookingFlowAccess } from '@api/hooks/useBookingFlowAccess';

interface RequireBookingFlowAccessProps {
  children: React.ReactNode;
  showWaitSpinner?: boolean;
  shouldRedirectIfDisabled?: boolean;
}

const RequireBookingFlowAccess: React.FC<RequireBookingFlowAccessProps> = ({
  children,
  showWaitSpinner = false,
  shouldRedirectIfDisabled = false,
}) => {
  const { isEnabled, loading } = useBookingFlowAccess();

  if (loading) {
    return showWaitSpinner ? <Spinner /> : null;
  }

  if (!isEnabled) {
    return shouldRedirectIfDisabled ? <RedirectForbidden /> : null;
  }

  return <>{children}</>;
};

export default RequireBookingFlowAccess;
